/* eslint-disable */
import {
  createStyles,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Theme,
  withStyles,
  Button,
  makeStyles,
  DividerProps,
} from "@material-ui/core";
import { Row } from "reactstrap";
import React, { Component } from "react";
import { Spacer, useStyles } from "@chakra-ui/react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import { StepIconProps } from "@material-ui/core/StepIcon";
import StepConnector from "@material-ui/core/StepConnector";
import Typography from "@material-ui/core/Typography";
import RiskProfil from "./RiskProfil";
import RiskCriterion from "./RiskCriterion";
import RiskQuestions from "./RiskQuestions";
import RiskAnswers from "./RiskAnswers";
import { withTranslation } from "react-i18next";
const styles = (theme: Theme) =>
  createStyles({
    stepper: {
      backgroundColor: "transparent",
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      margin: "2%",
    },
    instructions: {
      display: "flex",
      justifyContent: "center",
    },
  });
const useQontoStepIconStyles = makeStyles({
  active: {
    color: "#784af4",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  completed: {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
});
function QontoStepIcon(props: StepIconProps) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div>
      {completed ? (
        <Check style={{ color: "#ae0064" }} className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}
function getSteps() {
  return ["Risk Criteria", "Risk Profile", "Risk questions", "Risk Answers"];
}
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: "#AE0064",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#AE0064",
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

function getStepContent(step: number) {
  switch (step) {
    case 0:
      return <RiskCriterion />;
    case 1:
      return <RiskProfil />;
    case 2:
      return <RiskQuestions />;
    case 3:
      return <RiskAnswers />;
    default:
      return <div></div>;
  }
}
// export function Risk() {
//   return (
//     <div>
//       <Row
//         style={{
//           display: "block",
//           marginRight: "0px",
//           marginLeft: "0px",
//         }}
//       >
//         <div style={{ margin: "40px 16px" }}>
//           <Spacer />
//           <Button variant="contained" style={{ float: "right" }}>
//             rapport button
//           </Button>
//           <Spacer />
//           <TableContainer component={Paper}>
//             <Table stickyHeader aria-label="simple table">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Critere</TableCell>
//                   <TableCell>score</TableCell>
//                   <TableCell>poid</TableCell>
//                   <TableCell>profil</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 <TableRow>
//                   <TableCell>sdfg</TableCell>
//                   <TableCell>1</TableCell>
//                   <TableCell>20%</TableCell>
//                   <TableCell>profil</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <div style={{ fontSize: "10px", margin: "7px" }}>
//             date de la derniere evaluation: 20/06/2020
//           </div>
//         </div>
//       </Row>
//     </div>
//   );
// }
class RiskStepper extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeStep: 0,
    };
  }
  steps = getSteps();
  handleNext = () => {
    this.setState({
      activeStep: this.state.activeStep + 1,
    });
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  handleReset = () => {
    this.setState({ activeStep: 0 });
  };

  render() {
    const { classes, t } = this.props;

    return (
      <div>
        <div className={classes.stepper}>
          <Stepper
            style={{ backgroundColor: "transparent" }}
            alternativeLabel
            activeStep={this.state.activeStep}
            connector={<QontoConnector />}
          >
            {this.steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            {this.state.activeStep === this.steps.length ? (
              <div>
                <div className={classes.buttonContainer}>
                  <Button
                    style={{ backgroundColor: "#D8D8D8" }}
                    onClick={this.handleReset}
                    className={classes.button}
                  >
                    {t("RESET")}
                  </Button>
                </div>

                <Typography className={classes.instructions}>
                  {t("DONE")}
                </Typography>
              </div>
            ) : (
              <div>
                <div className={classes.buttonContainer}>
                  <Button
                    disabled={this.state.activeStep === 0}
                    onClick={this.handleBack}
                    className={classes.button}
                    style={{ backgroundColor: "#D8D8D8" }}
                  >
                    {t("BACK")}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleNext}
                    className={classes.button}
                    style={{ backgroundColor: "#AE0064" }}
                  >
                    {this.state.activeStep === this.steps.length - 1
                      ? t("DONE")
                      : t("NEXT")}
                  </Button>
                </div>
                <Typography className={classes.instructions}>
                  {getStepContent(this.state.activeStep)}
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(RiskStepper));
